import { render, staticRenderFns } from "./BorrowAreaPopup.vue?vue&type=template&id=3a0e2c06&scoped=true"
import script from "./BorrowAreaPopup.vue?vue&type=script&lang=js"
export * from "./BorrowAreaPopup.vue?vue&type=script&lang=js"
import style0 from "./BorrowAreaPopup.vue?vue&type=style&index=0&id=3a0e2c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0e2c06",
  null
  
)

export default component.exports